/**
 * 业绩目标网络请求模块
 * @author fighitngliu
 * @created 2022.05.24
 */
import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';
import { getDownloadPoolListLink } from '@/pages/leads/distribution/api';
import message from '@/utils/message';
import dialog from '@/utils/dialog';
import _ from 'lodash';

// 服务商业绩管理概览
const getAchievementOverview = (data) => {
  // agency/achievement/overview
  const url = getAgsApiUrl('agency_sales_portal/agency/achievement', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     // 广告费概览
  //     "performanceAdFeeOverviewVo": {
  //       "adFeeProgressRatio": 0, // 广告费进展值
  //       'timeProcess': 0.11,
  //       "agencyTargetAdFee": 800, // 广告费赋能设置目标数
  //       "realAdFee": 20, // 广告费实际完成数
  //       "salesTargetAdFee": 600, // 广告费设置目标数
  //       "targetProcessFinishedNumber": 0, // 进展已达成数
  //       "targetProcessUnFinishedAdvanceNumber": 6, // 进展未达成提前数
  //       "targetProcessUnFinishedBackwardGt20Number": 0, // 进展未达成落后20%以上数
  //       "targetProcessUnFinishedBackwardNumber": 9, // 进展未达成落后数
  //       "targetProcessUnFinishedNormalNumber": 7, // 进展未达成正常数
  //       "targetProcessUnFinishedNumber": 12 // 进展未达成数
  //     },
  //     // 订单概览
  //     "performanceOrderOverviewVo": {
  //       "agencyTargetOrderNumber": 200, // 订单赋能设置目标数量
  //       "orderProgressRatio": 0, // 订单进展值
  //       'timeProcess': 0.11,
  //       "realOrderNumber": 10, // 订单实际完成数量
  //       "salesTargetOrderNumber": 300, // 订单服务商设置目标数量
  //       "targetProcessFinishedNumber": 1, // 进展已达成数
  //       "targetProcessUnFinishedAdvanceNumber": 2, // 进展未达成提前数
  //       "targetProcessUnFinishedBackwardGt20Number": 3, // 进展未达成落后20%以上数
  //       "targetProcessUnFinishedBackwardNumber": 4, // 进展未达成落后数
  //       "targetProcessUnFinishedNormalNumber": 5, // 进展未达成正常数
  //       "targetProcessUnFinishedNumber": 6 // 进展未达成数
  //     }
  //   },
  //   "msg": "ok"
  // });
};

// 服务商业绩管理-风险提示
// achievement/risk/prompt
const getAchievementPrompt = (data = {}) => {
  const url = getAgsApiUrl('agency_sales_portal/agency/achievement/risk', 'prompt');
  const params = {
    method: 'GET',
    isCache: true,
    data,
  };
  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "adFeeBackwardGt20": 0, // 到款进展落后20%以上
  //     "orderBackwardGt20": 0 // 订单进展落后20%以上
  //   },
  //   "msg": "ok"
  // })
};

// 服务商业绩管理-风险提示
// agency_sales_portal/sale/achievement/risk/prompt
const myTargetPrompt = (data = {}) => {
  const url = getAgsApiUrl('agency_sales_portal/sale/achievement/risk', 'prompt');
  const params = {
    method: 'GET',
    isCache: true,
    data,
  };
  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "adFeeBackwardGt20": 0, // 到款进展落后20%以上
  //     "orderBackwardGt20": 0 // 订单进展落后20%以上
  //   },
  //   "msg": "ok"
  // })
};

// 服务商业绩列表
// /agency/achievement/search
const getAchievementSearch = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/agency/achievement', 'search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false)
  // return Promise.resolve({
  //   "code": 0,
  //   "data": [
  //     {
  //       "curTeamReportData": {
  //         "adFreActualNumber": 0,
  //         "adFreRatio": 0,
  //         "adFreTargetNumber": 0,
  //         "orderActualNumber": 8,
  //         "orderRatio": 0.8,
  //         "orderTargetNumber": 100,
  //         "positionIds": [
  //           0
  //         ],
  //         "roleMemo": "string",
  //         "saleId": 0,
  //         "targetStatus": "TARGET_STATUS_CONFORMANCE"
  //       },
  //       "employeeReportData": {
  //         "adFreActualNumber": 0,
  //         "adFreRatio": 0,
  //         "adFreTargetNumber": 0,
  //         "orderActualNumber": 8,
  //         "orderRatio": 0.8,
  //         "orderTargetNumber": 10,
  //         "positionIds": [
  //           0
  //         ],
  //         "roleMemo": "string",
  //         "saleId": 0,
  //         "targetStatus": "TARGET_STATUS_CONFORMANCE"
  //       },
  //       "teamId": 0
  //     }
  //   ],
  //   "msg": "ok"
  // })
    .then((res) => {
      const {
        setSales, // 返回体-服务商是否给销售设置了目标，ture: 已设置，false: 未设置
        teams,
      } = res.data;
      return {
        list: teams?.map((line) => {
          let resData = { ...line };
          // 团队
          if (line.curTeamReportData) {
            resData = { ...resData, ...line.curTeamReportData, isTeam: true };
          } else {
            resData = { ...resData, ...line.employeeReportData, isTeam: false };
          }
          resData = { ...resData, id: `${resData.teamId}-${resData.saleId}` };
          return resData;
        }),
        isEmpty: !setSales,
      };
    });
};

// 服务商过程列表
// agency_sales_portal/sales/process/list
const getProcessList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/process', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false)
    .then((res) => {
      const {
        setSales, // 返回体-服务商是否给销售设置了目标，ture: 已设置，false: 未设置
        teams,
      } = res.data;
      return {
        list: teams?.map((line) => {
          let resData = { ...line };
          // 团队
          if (line.curTeamReportData) {
            resData = { ...resData, ...line.curTeamReportData, isTeam: true };
          } else {
            resData = { ...resData, ...line.employeeReportData, isTeam: false };
          }
          resData = { ...resData, id: `${resData.teamId}-${resData.saleId}` };
          return resData;
        }),
        isEmpty: !setSales,
      };
    });
};


// agency_sales_portal/sales/process/overview
// 服务商过程目标概览
const getProcessOverview =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/process', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
};

// sale/achievement/overview
// 个人目标概览
const myTargetOverView = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sale/achievement', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, false, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "performanceAdFeeOverviewVo": {
  //       "adFeeProgressRatio": 0.3,
  //       "realAdFee": 3,
  //       "salesTargetAdFee": 10
  //     },
  //     "performanceOrderOverviewVo": {
  //       "orderProgressRatio": 0.2,
  //       "realOrderNumber": 2,
  //       "salesTargetOrderNumber": 10
  //     }
  //   },
  //   "msg": "ok"
  // });
};

// sale/achievement/search
// 个人目标列表
const myTargetList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sale/achievement', 'search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "conf": {
  //       "pageCount": 0,
  //       "pageIndex": 0,
  //       "pageSize": 0,
  //       "totalCount": 0
  //     },
  //     "items": [
  //       {
  //         "date": "20220808",
  //         "orderCnt": 0,
  //         "paymentCnt": 0
  //       }
  //     ]
  //   },
  //   "msg": "ok"
  // });
};

// sales/performance/target/list
// 业绩目标管理列表
const getPerformanceTargetList =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/performance/target', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "conf": {
  //       "pageCount": 0,
  //       "pageIndex": 0,
  //       "pageSize": 0,
  //       "totalCount": 500
  //     },
  //     "items": [
  //       {
  //         "adFee": 20,
  //         "orderNumber": 10,
  //         "saleId": 0,
  //         "saleName": "saleName",
  //         "saleRole": "saleRole",
  //         "superiorName": "superiorName",
  //         "teamId": 0,
  //         "teamName": "teamName",
  //         "dateMonth": '9',
  //       }
  //     ],
  //     "setSales": true
  //   },
  //   "msg": "ok"
  // });
};

// sales/process/target/list
// 过程目标管理列表
const getProgressTargetList =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/process/target', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
};


// sales/process/target
// 过程目标批量更新
const salesProgressUpdate =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/process/target', 'batch_save');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "msg": "ok"
  // });
};

// sales/performance/target/overview
// 销售目标概览
const getPerformanceTargetOverview =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales/performance/target', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "agencyAdFee": 1,
  //     "agencyOrderNumber": 2,
  //     "oaAdFee": 11,
  //     "oaOrderNumber": 22
  //   },
  //   "msg": "ok"
  // });
};

// salesPerformance/update
// 销售目标批量更新
const salesPerformanceUpdate =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/salesPerformance', 'update');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "msg": "ok"
  // });
};

// sales/delete
// 销售人员删除
const salesDelete =  (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales', 'delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "msg": "ok"
  // });
};

// sales/add
// 销售人员添加
const salesAdd = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/sales', 'add');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );
  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "msg": "ok"
  // });
};

// 下载员工模版
const downLoadUserTemplate = (data) => {
  const url = getAgsApiUrl('???', '???');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  // return smb_fetch(url, params);
  return Promise.resolve({
    'code': 0,
    'data': 'www.baidu.com',
    'msg': 'ok',
  });
};

// /agencyPerformance/update
// 服务商目标批量更新
const oaAgencyPerformanceUpdate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/agencyPerformance', 'update');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": '',
  //   "msg": "ok"
  // });
};

// oa/performance/list
// 赋能域业绩管理-列表
const oaPerformanceList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/oa/performance', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "conf": {
  //       "pageCount": 0,
  //       "pageIndex": 0,
  //       "pageSize": 0,
  //       "totalCount": 500
  //     },
  //     "items": [
  //       {
  //         "adFeeOverview": {
  //           "adFeeProgressRatio": 0.1,
  //           "agencyTargetAdFee": 2,
  //           "realAdFee": 3,
  //           "salesTargetAdFee": 4,
  //           "targetProcessFinishedNumber": 5,
  //           "targetProcessUnFinishedAdvanceNumber": 6,
  //           "targetProcessUnFinishedBackwardGt20Number": 7,
  //           "targetProcessUnFinishedBackwardNumber": 8,
  //           "targetProcessUnFinishedNormalNumber": 9,
  //           "targetProcessUnFinishedNumber": 10
  //         },
  //         "adFeeTargetProgress": "adFeeTargetProgress",
  //         "agencyId": 25699,
  //         "agencyName": "济南易搜",
  //         "oaaccounts": "渠道经理,asdf,adsf,sdf",
  //         "orderOverview": {
  //           "agencyTargetOrderNumber": 12,
  //           "orderProgressRatio": 0.31,
  //           "realOrderNumber": 14,
  //           "salesTargetOrderNumber": 15,
  //           "targetProcessFinishedNumber": 16,
  //           "targetProcessUnFinishedAdvanceNumber": 17,
  //           "targetProcessUnFinishedBackwardGt20Number": 18,
  //           "targetProcessUnFinishedBackwardNumber": 19,
  //           "targetProcessUnFinishedNormalNumber": 20,
  //           "targetProcessUnFinishedNumber": 21
  //         },
  //         "orderTargetProgress": "orderTargetProgress",
  //         "salesNumber": 1000,
  //         "targetStatus": '1'
  //       }
  //     ]
  //   },
  //   "msg": "ok"
  // });
};

// oa/performance/overview
// 赋能域业绩管理概览
const oaPerformanceOverview = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/oa/performance', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "performanceAdFeeOverviewVo": {
  //       "adFeeProgressRatio": 0.1,
  //       'timeProcess': 0.11,
  //       "agencyTargetAdFee": 2,
  //       "realAdFee": 3,
  //       "salesTargetAdFee": 4,
  //       "targetProcessFinishedNumber": 5,
  //       "targetProcessUnFinishedAdvanceNumber": 6,
  //       "targetProcessUnFinishedBackwardGt20Number": 7,
  //       "targetProcessUnFinishedBackwardNumber": 8,
  //       "targetProcessUnFinishedNormalNumber": 9,
  //       "targetProcessUnFinishedNumber": 10
  //     },
  //     "performanceOrderOverviewVo": {
  //       "agencyTargetOrderNumber": 11,
  //       "orderProgressRatio": 0.12,
  //       'timeProcess': 0.11,
  //       "realOrderNumber": 13,
  //       "salesTargetOrderNumber": 14,
  //       "targetProcessFinishedNumber": 15,
  //       "targetProcessUnFinishedAdvanceNumber": 16,
  //       "targetProcessUnFinishedBackwardGt20Number": 17,
  //       "targetProcessUnFinishedBackwardNumber": 18,
  //       "targetProcessUnFinishedNormalNumber": 19,
  //       "targetProcessUnFinishedNumber": 20
  //     }
  //   },
  //   "msg": "ok"
  // });
};

// oa/performance/target/list
// oa域给服务商设置的目标列表
const oaPerformanceTargetList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/oa/performance/target', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "conf": {
  //       "pageCount": 0,
  //       "pageIndex": 0,
  //       "pageSize": 0,
  //       "totalCount": 200
  //     },
  //     "items": [
  //       {
  //         "adFee": 200,
  //         "agencyId": 0,
  //         "agencyName": "string",
  //         "dateMonth": '202205',
  //         "orderNumber": 100
  //       }
  //     ],
  //     "overView": {
  //       "adFee": 0,
  //       "orderNumber": 0
  //     }
  //   },
  //   "msg": "ok"
  // });
};

// oa/performance/target/overview
// oa域给服务商设置的目标概览
const oaPerformanceTargetOverview = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/oa/performance/target', 'overview');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "adFee": 900,
  //     "orderNumber": 1000
  //   },
  //   "msg": "ok"
  // });
};

// 下载
// 通过 uuid 获取下载文件地址
const downLoadByUuid = (uuid) => {
  message.success('下载中，请稍候');
  getDownloadResult(uuid);
};
const getDownloadResult = (uuid) => {
  getDownloadPoolListLink({
    data: { uuid },
  }).then((res) => {
    if (_.isEmpty(res)) {
      setTimeout(() => {
        getDownloadResult(uuid);
      }, 1000);
      return;
    }
    if (res.code !== 0) {
      message.error(`获取下载链接失败 ${res.msg || res.message}`);
      return;
    }
    let link = res.link;
    if (/^http:\/\/.+/.test(link)) {
      link = link.replace('http://', 'https://');
    }
    window.open(link);
    dialog.notation(<span>文件地址：<a href={link} target='_blank' rel="noreferrer">{link}</a></span>, {
      title: '下载成功',
      iconType: 'success',
    }).then(() => {
      history.push('/agency/manage-employee/advertiser');
    });
  });
};

// agency_sales_portal/download/agency/process/list
// 下载服务商员工过程列表（服务商系统调用）
const downloadProcessList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/agency/process', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// agency_sales_portal/download/agency/achievement/search
// 下载服务商员工业绩列表（服务商系统调用）
const downloadAgencyAchievement = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/agency/achievement', 'search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// 下载服务商业绩列表（oa系统调用）
// agency_sales_portal/download/oa/performance/list
const downloadOaPerformanceList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/oa/performance', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};


// agency_sales_portal/download/performance/agencyToSalesTemplate
// 下载服务商给员工设置目标的模板（服务商系统调用）
const downloadAgencyToSalesTemplate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/performance', 'agencyToSalesTemplate');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// agency_sales_portal/download/sales/process/target/list
// 下载服务商给员工设置过程目标的模板（服务商系统调用）过程目标
const downloadProcessTargetTemplate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/sales/process/target', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// /agency_sales_portal/download/performance/channelToAgencyTemplate
// 下载渠道给服务商设置目标的模板（oa系统调用）
const downloadChannelToAgencyTemplate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/performance', 'channelToAgencyTemplate');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// /agency_sales_portal/download/sale/achievement/search
// 下载员工个人每日目标列表（服务商系统调用）
const downloadSaleAchievementSearch = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/sale/achievement', 'search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};


// precheck 复制
// agency_sales_portal/sales/target/precheck
const preCheckCopyTarget = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/sales/target/precheck',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
};

// 复制目标
// agency_sales_portal/sales/target/copy
const copyTarget = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/sales/target/copy',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
};

// 服务商系统里 有效新客 概览
const userCustomerOverView = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/agency/valid-new-customer', 'overview');
  const params = {
    method: 'GET',
    isCache: true,
    data,
  };

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'data': {
  //     "valid_new_customer_total": {
  //       "target_number": 100,
  //       "completed_number": 40,
  //       "expectation_percent": 20.5
  //     },
  //     "valid_new_customer_common": {
  //       "completed_number": 40
  //     },
  //     "valid_new_customer_nearby_push": {
  //       "completed_number": 30
  //     },
  //     "valid_new_customer_sg": {
  //       "completed_number": 30
  //     }
  //   },
  //   'msg': 'ok',
  // });
};

// 服务商系统里 有效新客 汇总数据
const userCustomerData = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/agency/valid-new-customer', 'statistic');
  const params = {
    method: 'GET',
    isCache: true,
    data,
  };

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'data': {
  //     "new_customer_number": 10,
  //     "prepare_new_customer_number": 20,
  //     "valid_new_customer_number": 30,
  //   },
  //   'msg': 'ok',
  // });
};

// 服务商系统里 有效新客 列表
const userCustomerList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/agency/valid-new-customer', 'search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'data': {
  //     "conf": {
  //       "page": 1,
  //       "page_size": 10,
  //       "total_num": 1,
  //       "total_page": 1
  //     },
  //     list: [
  //       {
  //         "enterprise_name": "快量网络科技(北京)有限公司",
  //         "is_valid_vew_customer": 1,
  //         "valid_new_customer_type": "当季-常规",
  //         "agent_new_valid_date": "2022-09-20",
  //         "account_id": 78384,
  //         "account_status": "正常",
  //         "account_created_time": "2022-08-01 15:23:26",
  //         "balance": 0,
  //         "total_cost": 500000,
  //         "common_cost": 300000,
  //         "sg_cost": 100000,
  //         "nearby_push_cost": 1000,
  //         "lead_id": 111,
  //         "lead_progress_status": '线索',
  //         "lead_abstract_status": '详细状态',
  //         "lead_owner_id": '线索跟进销售ID',
  //         "lead_owner_name": '线索跟进销售姓名',
  //         "operator_names": "张三,李四,王五,赵六"
  //       },
  //       {
  //         "enterprise_name": "快量网络科技(北京)有限公司",
  //         "is_valid_vew_customer": 1,
  //         "valid_new_customer_type": "当季-常规",
  //         "agent_new_valid_date": "2022-09-20",
  //         "account_id": 78384,
  //         "account_status": "正常",
  //         "account_created_time": "2022-08-01 15:23:26",
  //         "balance": 0,
  //         "total_cost": 500000,
  //         "common_cost": 300000,
  //         "sg_cost": 100000,
  //         "nearby_push_cost": 1000,
  //         "lead_id": 222,
  //         "lead_progress_status": '线索',
  //         "lead_abstract_status": '详细状态',
  //         "lead_owner_id": '线索跟进销售ID',
  //         "lead_owner_name": '线索跟进销售姓名',
  //         "operator_names": "张三,李四,王五,赵六"
  //       },
  //       {
  //         "enterprise_name": "快量网络科技(北京)有限公司2",
  //         "is_valid_vew_customer": 1,
  //         "valid_new_customer_type": "当季-常规",
  //         "agent_new_valid_date": "2022-09-20",
  //         "account_id": 78384,
  //         "account_status": "正常",
  //         "account_created_time": "2022-08-01 15:23:26",
  //         "balance": 0,
  //         "total_cost": 500000,
  //         "common_cost": 300000,
  //         "sg_cost": 100000,
  //         "nearby_push_cost": 1000,
  //         "lead_id": 222,
  //         "lead_progress_status": '线索',
  //         "lead_abstract_status": '详细状态',
  //         "lead_owner_id": '线索跟进销售ID',
  //         "lead_owner_name": '线索跟进销售姓名',
  //         "operator_names": "张三,李四,王五,赵六"
  //       },
  //       {
  //         "enterprise_name": "快量网络科技(北京)有限公司",
  //         "is_valid_vew_customer": 1,
  //         "valid_new_customer_type": "当季-常规",
  //         "agent_new_valid_date": "2022-09-21",
  //         "account_id": 78384,
  //         "account_status": "正常",
  //         "account_created_time": "2022-08-01 15:23:26",
  //         "balance": 0,
  //         "total_cost": 500000,
  //         "common_cost": 300000,
  //         "sg_cost": 100000,
  //         "nearby_push_cost": 1000,
  //         "lead_id": 222,
  //         "lead_progress_status": '线索',
  //         "lead_abstract_status": '详细状态',
  //         "lead_owner_id": '线索跟进销售ID',
  //         "lead_owner_name": '线索跟进销售姓名',
  //         "operator_names": "张三,李四,王五,赵六"
  //       },
  //       {
  //         "enterprise_name": "快量网络科技(北京)有限公司",
  //         "is_valid_vew_customer": 1,
  //         "valid_new_customer_type": "当季-常规",
  //         "agent_new_valid_date": "2022-09-21",
  //         "account_id": 78384,
  //         "account_status": "正常",
  //         "account_created_time": "2022-08-01 15:23:26",
  //         "balance": 0,
  //         "total_cost": 500000,
  //         "common_cost": 300000,
  //         "sg_cost": 100000,
  //         "nearby_push_cost": 1000,
  //         "lead_id": 222,
  //         "lead_progress_status": '线索',
  //         "lead_abstract_status": '详细状态',
  //         "lead_owner_id": '线索跟进销售ID',
  //         "lead_owner_name": '线索跟进销售姓名',
  //         "operator_names": "张三,李四,王五,赵六"
  //       },
  //     ],
  //   },
  //   'msg': 'ok',
  // });
};

// 服务商系统里 有效新客 列表下载
const userCustomerListDownload = (data) => {
  const url = getAgsApiUrl('agency_sales_portal/download/agency/valid-new-customer', 'list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );
  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// oa域有效新客业绩管理-获取列表
const getEffectiveList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const path = data.checkTheServiceDimensions ? '/agency_sales_portal/oa/agency/group/licence/list' : '/agency_sales_portal/oa/group/licence/list';
  delete data.checkTheServiceDimensions ;
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path,
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'msg': '',
  //   'data': {
  //     'conf': {
  //       'pageIndex': 1,
  //       'pageSize': 20,
  //       'totalCount': 1,
  //       'pageCount': 1,
  //     },
  //     'items': [
  //       {
  //         'agencyGroupId': 26235667,
  //         'agencyGroupName': '集团名称',
  //         'licenceArea': '北京',
  //         'agencyName': '服务商名称',
  //         'dateQuarter': '2022-q1',
  //         'oaAccounts': '渠道名称',
  //         'validNewCustomerCommonNum': 17,
  //         'validNewCustomerNearbypushNum': 37,
  //         'validNewCustomerSogouNum': 57,
  //         'validNewCustomerProgress': 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20',
  //         'validNewCustomerOverview': {
  //           'realNum': 30,
  //           'targetNum': 100,
  //           'numProgressRatio': 0.33,
  //           'targetProcessFinishedNumber': 0,
  //           'targetProcessUnFinishedNumber': 7,
  //           'targetProcessUnFinishedAdvanceNumber': 0,
  //           'targetProcessUnFinishedNormalNumber': 0,
  //           'targetProcessUnFinishedBackwardNumber': 0,
  //           'targetProcessUnFinishedBackwardGt20Number': 0,
  //         },
  //         'targetStatus': 'TARGET_STATUS_NON_CONFORMANCE',
  //       },
  //     ],
  //   },
  //   'trace_id': 'a9b9cdae7fce11edb097f1a926a7f980',
  // });
};

// oa域有效新客业绩管理概览
const oaEffectiveOverview = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/oa/group/licence/overview',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'msg': '',
  //   'data': {
  //     'agencyGroupId': 26235667,
  //     'agencyGroupName': '集团名称',
  //     'licenceArea': '北京',
  //     'agencyName': '服务商名称',
  //     'dateQuarter': '2022-q1',
  //     'oaAccounts': '渠道名称',
  //     'validNewCustomerCommonNum': 107,
  //     'validNewCustomerNearbypushNum': 17,
  //     'validNewCustomerSogouNum': 7,
  //     'validNewCustomerProgress': 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20',
  //     'validNewCustomerOverview': {
  //       'realNum': 10,
  //       'targetNum': 200,
  //       'numProgressRatio': 0,
  //       'targetProcessFinishedNumber': 10,
  //       'targetProcessUnFinishedNumber': 10,
  //       'targetProcessUnFinishedAdvanceNumber': 10,
  //       'targetProcessUnFinishedNormalNumber': 10,
  //       'targetProcessUnFinishedBackwardNumber': 10,
  //       'targetProcessUnFinishedBackwardGt20Number': 10,
  //     },
  //     'targetStatus': 'TARGET_STATUS_NON_CONFORMANCE',
  //   },
  //   'trace_id': 'eecd730c806411edb0972fd04daee121',
  // });
};
// oa域有效新客业绩管理-风险提示
const oaEffectiveRiskInfo = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/oa/group/licence/risk/prompt',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'msg': '',
  //   'data': {
  //     'newCustomerBackwardGt20': '测试',
  //   },
  //   'trace_id': 'eecd730c806411edb0972fd04daee121',
  // });
};

// oa域有效新客业绩管理-下载业绩目标模版
const downloadEffectiveTemplate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/download/group/licence/target/list',
        req: data,
      },
    },
  );
  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};
// oa域有效新客业绩管理-下载数据
const downloadEffectiveData = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: data?.checkTheServiceDimensions ? '/agency_sales_portal/download/oa/agency/group/licence/list' : '/agency_sales_portal/download/oa/group/licence/list',
        req: data,
      },
    },
  );
  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// oa域有效新客业绩管理-修改目标-获取列表
const getEffectiveEditList = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/oa/group/licence/target/list',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'msg': '',
  //   'data': {
  //     'conf': {
  //       'pageIndex': 1,
  //       'pageSize': 20,
  //       'totalCount': 1,
  //       'pageCount': 1,
  //     },
  //     'items': [
  //       {
  //         'agencyGroupId': 17192753,
  //         'agencyGroupName': '集团名称',
  //         'licenceArea': '北京',
  //         'dateQuarter': '2022-Q1',
  //         'validNewCustomerNum': 0,
  //         'agencyName': '服务商a',
  //       },
  //     ],
  //   },
  //   'trace_id': '321cf3637fcb11edb09793deabe5f1c2',
  // });
};

// oa域有效新客业绩管理-修改目标-目标批量更新
const oaEffectiveUpdate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/oa/group/licence/target/update',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'data': '',
  //   'msg': 'ok',
  // });
};

// oa域有效新客业绩管理-修改目标-下载模版
const downloadEffectiveEditTemplate = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/download/group/licence/target/list',
        req: data,
      },
    },
  );
  return smb_fetch(url, params, true, false).then((res) => {
    if (res.code === 0) {
      downLoadByUuid(res.data.uuid);
    }
  });
};

// oa域有效新客业绩管理-修改目标概览
const oaEffectiveEditTargetOverview = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'post');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      data: {
        path: '/agency_sales_portal/oa/group/licence/target/overview',
        req: data,
      },
    },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   'code': 0,
  //   'data': {
  //     'validNewCustomerNum': 3,
  //   },
  //   'msg': 'ok',
  // });
};

// v2/lead/sign/first-page-statistics
// 首页代办概览
const myTodoOverView = (data) => {
  const url = getAgsApiUrl('v2/lead/sign', 'first-page-statistics');
  const params = {
    method: 'GET',
    isCache: true,
    data,
  };
  return smb_fetch(url, params, true, false);
};


export default {
  getAchievementOverview,
  getAchievementPrompt,
  getAchievementSearch,

  myTodoOverView,
  myTargetOverView,
  myTargetList,
  myTargetPrompt,

  getPerformanceTargetList,
  getPerformanceTargetOverview,
  salesPerformanceUpdate,
  salesDelete,
  salesAdd,
  downLoadUserTemplate,

  oaAgencyPerformanceUpdate,
  oaPerformanceList,
  oaPerformanceOverview,
  oaPerformanceTargetList,
  oaPerformanceTargetOverview,

  getProcessOverview,
  getProcessList,
  getProgressTargetList,
  salesProgressUpdate,

  downloadProcessList,
  downloadAgencyAchievement,
  downloadSaleAchievementSearch,
  downloadOaPerformanceList,
  downloadChannelToAgencyTemplate,
  downloadAgencyToSalesTemplate,
  downloadProcessTargetTemplate,

  preCheckCopyTarget,
  copyTarget,

  userCustomerOverView,
  userCustomerData,
  userCustomerList,
  userCustomerListDownload,
  getEffectiveList,
  oaEffectiveOverview,
  oaEffectiveRiskInfo,
  downloadEffectiveTemplate,
  downloadEffectiveData,

  getEffectiveEditList,
  oaEffectiveUpdate,
  downloadEffectiveEditTemplate,
  oaEffectiveEditTargetOverview,

};
